import imageUrl, { gdOssUrl } from "@/utils/imageUrl";
import classNames from "classnames";
import { useMemo } from "react";
import Image from "../Image";
import styles from "./index.module.less";

interface HBAvatarProps {
  user?: any;
  className?: string;
  imgUrl?: string;
  shape?: "square" | "circle";
  size?: number;
}

export default function HBAvatar({
  user,
  shape = "square",
  size = 75,
  className,
  imgUrl,
}: HBAvatarProps) {
  const avatarImgUrl = useMemo<string>(() => {
    if (imgUrl) {
      return gdOssUrl(imgUrl, { width: size });
    }
    if (user?.avatar) {
      // 目前头像最小是 75宽度
      return imageUrl(user.avatar, { width: size, rect: "sq" });
    } else {
      return gdOssUrl(
        "https://cdn.dancf.com/fe-assets/img/c62d185173c48b4c73f90ea6b7acee33.png"
      );
    }
  }, [imgUrl, user?.avatar, size]);

  return (
    <Image
      className={classNames(styles.avatar, styles[shape], className)}
      src={avatarImgUrl}
      alt={user?.username}
      width={size}
      height={size}
    />
  );
}
